export function fetch(url, params = {}) {
    return new Promise((resolve, reject) => {
        this.$http.get(url, {
            params: params
        }).then(response => {
            resolve(response ? response.data : {});
        }).catch(err => {
            reject(err);
        });
    });
}

export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
        this.$http.post(url, params).then(response => {
            resolve(response ? response.data : {});
        }).catch(err => {
            reject(err);
        });
    });
}

export function patch(url, params = {}) {
    return new Promise((resolve, reject) => {
        this.$http.patch(url, {
            params: params
        }).then(response => {
            resolve(response ? response.data : {});
        }).catch(err => {
            reject(err);
        });
    });
}

export function put(url, params = {}) {
    return new Promise((resolve, reject) => {
        this.$http.put(url, {
            params: params
        }).then(response => {
            resolve(response ? response.data : {});
        }).catch(err => {
            reject(err);
        });
    });
}